const theme = {
  main: '#8f94fb',
  secondary: '#4e54c8'
};

export default theme;



// WEBPACK FOOTER //
// ./src/styles/theme/theme.js